import { render } from "./TaskDialog.vue?vue&type=template&id=a8e6b3b6&scoped=true"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=a8e6b3b6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e6b3b6"]])

export default __exports__